// Thin wrapper around Telegram HapticFeedback. Silent no-op outside Telegram.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const hf = () => (window.Telegram?.WebApp as any)?.HapticFeedback

export const haptics = {
  // Taps, opens: 'light'. Confirms, sends: 'medium'. Critical actions: 'heavy'.
  impact: (style: 'light' | 'medium' | 'heavy' | 'rigid' | 'soft' = 'light') =>
    hf()?.impactOccurred(style),
  // Outcomes: 'success' / 'error' / 'warning'
  notification: (type: 'error' | 'success' | 'warning') =>
    hf()?.notificationOccurred(type),
  // Selection changes: model picker, category chip
  selection: () =>
    hf()?.selectionChanged(),
}
